module.exports = __webpack_public_path__ + "images/icons_v2/child-lock-off-b92b39c2.svg";